import { z } from 'zod';

/** Liste controllate del mondo Task: stato e priorità. */

export const StatoTask = z.enum(['Da fare', 'In corso', 'Completata', 'Sospeso', 'Annullato']);
export type StatoTask = z.infer<typeof StatoTask>;

export const PrioritaTask = z.enum(['Bassa', 'Media', 'Alta']);
export type PrioritaTask = z.infer<typeof PrioritaTask>;
